import {
  FieldConfig,
  FieldDataTypes,
  MediaAssetResourceInterface,
  MediaTypes,
  nNumber,
  nString,
  Uuid,
} from '@hidat/huijs-common';
import {
  ResourceConfig,
  ResourceSystemFields,
  SoftDeleteResource,
} from '@hidat/huijs-resource';
import { splixerFieldConfigs } from './splixer-fields.const';
import { SplixerResourceInterface } from './splixer-resource.interface';

export const BrandingAssetConfig = new ResourceConfig(
  'BrandingAsset',
  'branding_assets',
  true,
  true,
)
  .addFields([
    splixerFieldConfigs.guidId,
    splixerFieldConfigs.status,
    ResourceSystemFields.createdAt,
    ResourceSystemFields.updatedAt,
  ])
  .addFields([
    new FieldConfig('mediaType'),
    new FieldConfig('role'),
    new FieldConfig('usageCode'),
    new FieldConfig('repoAssetId', FieldDataTypes.UID).setEditable(false),
    new FieldConfig('previewAssetId', FieldDataTypes.UID).setEditable(false),
    new FieldConfig('resourceType').setEditable(false),
    new FieldConfig('resourceId', FieldDataTypes.INTEGER).setEditable(false),
    new FieldConfig('permalinkUrl').setEditable(false),
    new FieldConfig('shortCode').setEditable(false),
    new FieldConfig('note'),
  ]);

export interface BrandingAssetInterface
  extends
    SplixerResourceInterface<Uuid>,
    SoftDeleteResource,
    MediaAssetResourceInterface {
  tenantId: Uuid | undefined;

  resourceType: nString;
  resourceId: nNumber;
  role: nString;
  usageCode: nString;
  permalinkUrl: nString;
  shortCode: nString;
  note: nString;

  mediaType: MediaTypes | undefined;
  repoAssetId: Uuid | undefined;
  previewAssetId: Uuid | undefined | null;
}
